import { StyleSheet } from 'react-native';
import Button from 'theme/Button'
import { ThemedValues } from 'styles/themed'
import Icon from 'components/atoms/Icon'
import { IconSystemConstants } from 'utils/constants/IconNameConstants'
import i18n from 'utils/i18n'
import React from 'react'
import { colorList } from 'utils/colors'

const HomeButtonView = ({ onPress }) => {
	
	return (
		<Button
			style={staticStyles.buttonFlex1}
			accessoryLeft={ <Icon icon={ IconSystemConstants.HOME} color={ colorList.WHITE.primary } /> }
			onPress={ onPress }>
			
			{ i18n.t('page.transport.button_home') }
		</Button>
	)
}
const staticStyles = StyleSheet.create({
	buttonFlex1: {
		flex: 1,
	},
});

export default HomeButtonView;
